import { usePageTitle } from "../hooks/usePageTitle";
import { recordTitle } from "./recordTitle";
import { useEntityPage } from "./useEntityPage";

/**
 * The default switched off, and no other view this record and user qualify for -
 * explained rather than rendered as an empty form. Named in the tab all the same.
 */
export function EntityPageNoView() {
  const { definition, record } = useEntityPage();

  usePageTitle(recordTitle(record ?? {}, definition?.identity));

  return (
    <div className="container-fluid p-4">
      <div className="alert alert-warning">
        <p className="mb-1 fw-medium">
          There is no form available for this record.
        </p>
        <p className="mb-0">
          Its default view has been deactivated and no other view
          applies to you. An administrator can reactivate it, or
          create a view for this page.
        </p>
      </div>
    </div>
  );
}

export default EntityPageNoView;
